<template>
  <div class="contrato-container">
    <div class="header-section">
      <div class="logo-area logo-left">
        <img :src="logoSuape" alt="Logo SUAPE" class="img-fluid logo-img" />
      </div>
      <div class="title-center">
        CRONOGRAMA FÍSICO-FINANCEIRO
      </div>
      <div class="logo-area logo-right">
        <img v-if="dados.logoFornecedorUrl" :src="dados.logoFornecedorUrl" alt="Logo Contratada" class="img-fluid logo-img" />
        <div v-else class="box-placeholder">
          Logomarca da empresa<br>(consórcio) contratada
        </div>
      </div>
    </div>

    <div class="data-table">
      <div class="table-row">
        <div class="cell left-col">
          <span class="label">CONTRATO:</span>
          <span class="value">{{ dados.numeroContrato }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">MEDIÇÃO:</span>
          <span class="value">{{ dados.medicao }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">CONTRATADA:</span>
          <span class="value">{{ dados.contratada }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">PERÍODO:</span>
          <span class="value">{{ dados.periodo }}</span>
        </div>
      </div>

      <div class="table-row">
        <div class="cell left-col">
          <span class="label">ORDEM DE SERVIÇO:</span>
          <span class="value">{{ dados.ordemServico }}</span>
        </div>
        <div class="cell right-col">
          <span class="label">VALOR DO CONTRATO:</span>
          <span class="value">{{ dados.valorContrato | currency }}</span>
        </div>
      </div>

      <div class="table-row merged-row">
        <div class="cell left-col full-center">
          <span class="label">OBJETO:</span>
          <span class="value object-text">{{ dados.objeto }}</span>
        </div>

        <div class="right-stack">
          <div class="cell stack-item border-bottom">
            <span class="label">FINANCEIRO PROJETADO:</span>
            <span class="value">{{ dados.financeiroProjetado | currency }}</span>
          </div>

          <div class="cell stack-item">
            <span class="label">FINANCEIRO EXECUTADO:</span>
            <span class="value">{{ dados.financeiroExecutado | currency }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="content-slot mt-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContratoHeader',
  props: {
    dados: { type: Object, required: true },
    logoSuape: { type: String, default: '/img/logo.png' }
  },
  filters: {
    currency(value) {
      if (value === null || value === undefined) return 'R$ 00,00'
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }
}
</script>

<style scoped>
.contrato-container {
  font-family: Arial, Helvetica, sans-serif;
  color: #000;
  width: 100%;
  background: #fff;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  margin-bottom: 5px;
  min-height: 80px;
}

.logo-area { width: 20%; display: flex; align-items: center; }
.logo-left { justify-content: flex-start; }
.logo-right { justify-content: flex-end; }
.logo-img { max-width: 100%; max-height: 100px; object-fit: contain; }
.title-center { flex-grow: 1; text-align: center; font-weight: 600; font-size: 1.2rem; text-transform: uppercase; }
.box-placeholder { border: 1px solid #000; padding: 5px; font-weight: 500; text-align: center; font-size: 0.8rem; width: 100%; }

.data-table {
  border: 1px solid #000;
  display: flex;
  flex-direction: column;
}

.table-row {
  display: flex;
  border-bottom: 1px solid #000;
}

.table-row:last-child {
  border-bottom: none;
}

.cell {
  padding: 2px 5px;
  display: flex;
  align-items: center;
  font-size: 0.85rem;
}

.left-col {
  width: 60%;
  border-right: 1px solid #000;
}

.right-col {
  width: 40%;
}

.full-center {
  align-items: center;
  height: auto;
}

.right-stack {
  width: 40%;
  display: flex;
  flex-direction: column;
}

.stack-item {
  flex-grow: 1;
  display: flex;
  align-items: center;
  padding: 2px 5px;
  min-height: 25px;
}

.border-bottom {
  border-bottom: 1px solid #000;
}

.label {
  font-weight: 600;
  text-transform: uppercase;
  margin-right: 5px;
  white-space: nowrap;
}

.value {
  font-weight: 400;
  flex-grow: 1;
}

.object-text {
  white-space: normal;
  line-height: 1.2;
}
</style>
